import { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'

type MenuItem = {
  id: string
  name: string
  url?: string
  icon?: string
}

export default function MenuBlock ({
  payload
}: BlockProps) {
  // Extract menu items from payload
  const menuItems = (payload?.items as MenuItem[]) || []

  if (!menuItems.length) {
    return null
  }

  return (
    <div className={styles.root__menu}>
      <div className={styles.menu__grid}>
        {menuItems.map((item) => (
          <a
            key={item.id}
            href={item.url || '#'}
            className={styles.menu__item}
          >
            {item.icon && (
              <div className={styles.menu__icon}>
                <img src={item.icon} alt={item.name} />
              </div>
            )}
            <span className={styles.menu__label}>{item.name}</span>
          </a>
        ))}
      </div>
    </div>
  )
}